export const theme = {
  colors: {
    white: "#ffffff",
    blue: "#1890FF",
    lightBlue: "#87E8DE80",
    gray: "#595959",
    middleGray: "#8C8C8C",
    neroGray: "#262626",
    lightGray: "#BFBFBF",
    lightGray2: "#898989",
    lightGray3: "#EDEDED",
    pureGray: "#FAFAFA",
    lightRed: "#FFF2F0",
    lightRed1: "#FFCCC7",
    lightRed2: "#DC001F33",
    darkBlue: "#1F2731",
    red: "#F5222D",
    red1: "#DC001F",
    dustRed1: "#FFF1F0",
    dustRed5: "#FF4D4F",
    orange: "#FA541C",
    grayLightWhite: "#D9D9D9",
    lightGrayAnt: "#f0f0f0",
    lightGrayWhite: "#F5F5F5",
    tabulateItemText: "#EAEAEA",
    lightGreen: "#F6FFED",
    lightGreen1: "#C1EE9F",
    lightGreen2: "#B7EB8F80",
    green: "#52C41A",
    black: "#000000",
    default: "#F5222D",
    lightOrange: "#FFBB96",
    lightOrange2: "#FFE58F80",
    volcano1: "#FFF2E8",
    instat: "#0F7335",
    calendula: "#FFC53D",
    coolBlue: "#F0F2F5",
  },
};
